class ScrollTo {
    constructor(el, scrollTarget, clickTarget, eventName) {
        this.$el = el;
        this.$customEventName = eventName;
        this.$clickTarget = el.querySelector(clickTarget);
        this.$scrollTarget = el.querySelector(scrollTarget);
        if (this.$clickTarget) {
            this.$clickTarget.addEventListener('click', () => this.scroll(this.$scrollTarget));
        }
    }

    scroll(target) {
      target.scrollIntoView();

      this.dispatchEvent(
        new CustomEvent(this.$customEventName, {
            detail: { target },
            bubbles: true,
            target: this,
        })
      );
    }

    dispatchEvent(event) {
        this.$el.dispatchEvent(event);
    }
}

export default ScrollTo;
